// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1hXaf"};